// @ts-nocheck
(() => {
  function handleSwatchClick(event) {
    const swatch = event.target.closest('.product-card-swatches__item');
    if (!swatch) return;
    const swatchList = swatch.closest('[data-card-swatches]');
    if (!swatchList) return;

    event.preventDefault();
    event.stopPropagation();

    const productUrl = swatch.dataset.productUrl;
    const imageUrl = swatch.dataset.imageUrl;
    const productTitle = swatch.dataset.productTitle;
    const priceHtml = swatch.dataset.priceHtml;
    const badgeHtml = swatch.dataset.badgeHtml;

    const card =
      swatch.closest('product-card') ||
      swatch.closest('.product-card') ||
      swatchList.parentElement;
    if (!card) return;

    if (productUrl) {
      card.querySelectorAll('a[href]').forEach((/** @type {HTMLAnchorElement} */ link) => {
        if (link.closest('[data-card-swatches]')) return;
        link.href = productUrl;
      });
      if ('productTransition' in card.dataset && card.dataset.productTransition === 'true') {
        card.dataset.featuredMediaUrl = imageUrl || '';
      }
    }

    if (imageUrl) {
      const galleryImg = card.querySelector(
        '.product-media-container img, .card-gallery img, .product-card__image img, .product-card img'
      );
      if (galleryImg) {
        galleryImg.removeAttribute('srcset');
        galleryImg.removeAttribute('sizes');
        galleryImg.src = imageUrl;
      }

      const slides = card.querySelectorAll('slideshow-slide');
      slides.forEach((/** @type {HTMLElement} */ slide, /** @type {number} */ index) => {
        if (index === 0) return;
        slide.setAttribute('hidden', '');
        slide.style.display = 'none';
      });
    }

    if (productTitle) {
      const originalTitle = swatchList.dataset.originalTitle;
      const titleCandidates = [
        'a[ref="productTitleLink"] p[role="heading"]',
        'a[ref="productTitleLink"] [role="heading"]',
        '[ref="productTitleLink"]',
        'p[role="heading"]',
        '[role="heading"]',
        '.title-text',
        '.product-card__title',
        'product-title .title-text',
        'product-title',
      ];
      let updated = false;
      for (const selector of titleCandidates) {
        const nodes = card.querySelectorAll(selector);
        if (nodes.length) {
          nodes.forEach((node) => {
            node.textContent = productTitle;
          });
          updated = true;
          break;
        }
      }
      if (!updated && originalTitle) {
        const walker = document.createTreeWalker(card, NodeFilter.SHOW_TEXT);
        const nodesToReplace = [];
        let n;
        while ((n = walker.nextNode())) {
          if (n.nodeValue && n.nodeValue.trim() === originalTitle.trim()) {
            nodesToReplace.push(n);
          }
        }
        nodesToReplace.forEach((n) => {
          n.nodeValue = productTitle;
        });
      }
    }

    if (priceHtml) {
      const priceContainer = card.querySelector('product-price [ref="priceContainer"], product-price');
      if (priceContainer) {
        const existingContainer = priceContainer.querySelector('[ref="priceContainer"]');
        if (existingContainer) {
          existingContainer.outerHTML = priceHtml;
        } else {
          priceContainer.innerHTML = priceHtml;
        }
      }
    }

    const badgeContainer = card.querySelector('.product-badges');
    if (badgeContainer) {
      badgeContainer.innerHTML = badgeHtml || '';
    }

    swatchList
      .querySelectorAll('.product-card-swatches__item--active')
      .forEach((/** @type {Element} */ el) => el.classList.remove('product-card-swatches__item--active'));
    swatch.classList.add('product-card-swatches__item--active');
  }

  document.addEventListener('click', handleSwatchClick);
})();
